import { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { trackDailyActivity } from '../services/dailyActivityTracker';

export function DailyActivityTracker() {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      // Track daily activity when component mounts or user changes
      trackDailyActivity(user.id);
    }
  }, [user]);

  // This component doesn't render anything
  return null;
}